export default "__VITE_ASSET__Bra48Aiq__"